import { render, staticRenderFns } from "./Lugares.vue?vue&type=template&id=0712309c&scoped=true"
import script from "./Lugares.vue?vue&type=script&lang=js"
export * from "./Lugares.vue?vue&type=script&lang=js"
import style0 from "./Lugares.vue?vue&type=style&index=0&id=0712309c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0712309c",
  null
  
)

export default component.exports